(() => {
  'use strict';

  const pagePath = () => window.location.pathname || '/';
  const pathFrom = (value) => {
    try { return new URL(value, window.location.origin).pathname; }
    catch (_) { return String(value || '').split('?')[0].split('#')[0]; }
  };
  const publish = (name, data = {}) => {
    const analytics = window.Shopify?.analytics;
    if (typeof analytics?.publish !== 'function') return;
    Promise.resolve(
      analytics.publish(`evashu:${name}`, {
        page_path: pagePath(),
        ...data,
      })
    ).catch(() => {});
  };

  const publishFinderCompletion = (button) => {
    window.setTimeout(() => {
      const finder = button.closest('.eih-finder');
      const home = finder?.closest('[data-eih-home]');
      const result = home?.querySelector('[data-eih-result]');
      if (!result || result.hidden || !result.classList.contains('is-visible')) return;
      if (result.dataset.eihAnalyticsCompleted === 'true') return;
      result.dataset.eihAnalyticsCompleted = 'true';

      const answers = [...result.querySelectorAll('[data-eih-result-copy] p')]
        .map((node) => node.textContent.replace(/^\s*\d+\.\s*/, '').trim())
        .filter(Boolean);

      publish('finder_completed', {
        answers,
        result_path: pathFrom(result.querySelector('[data-eih-result-link]')?.href),
      });
    }, 0);
  };

  const publishToolCompletion = (form) => {
    if (form.matches('[data-finder-form]')) publish('crystal_finder_completed', { tool: 'crystal_finder' });
    else if (form.matches('[data-birth-form]')) publish('birthstone_zodiac_completed', { tool: 'birthstone_zodiac' });
    else if (form.matches('[data-angel-form]')) publish('angel_number_completed', { tool: 'angel_number' });
    else if (form.matches('[data-chakra-form]')) publish('chakra_assessment_completed', { tool: 'chakra_assessment' });
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (form.matches('[data-finder-form],[data-birth-form],[data-angel-form],[data-chakra-form]')) {
      window.setTimeout(() => publishToolCompletion(form), 0);
    }
  }, true);

  document.addEventListener('change', (event) => {
    const care = event.target.closest?.('[data-care-select]');
    if (care && care.value) {
      publish('crystal_care_lookup', { tool: 'care_lookup', material_key: String(care.value) });
      return;
    }

    const market = event.target.closest?.(
      'localization-form select[name="country_code"], localization-form select[name="locale_code"], form[action*="/localization"] select'
    );
    if (market?.name && market.value) {
      publish('market_selector_changed', {
        selector: String(market.name),
        selection: String(market.value),
      });
    }
  }, true);

  document.addEventListener('click', (event) => {
    const next = event.target.closest?.('[data-eih-next]');
    if (next) publishFinderCompletion(next);

    const filter = event.target.closest?.('[data-eih-filter], [data-eih-collection-tab]');
    if (filter) {
      publish('homepage_filter_selected', {
        filter: String(
          filter.dataset.eihFilter ||
          filter.dataset.eihCollectionTab ||
          filter.textContent ||
          ''
        ).trim().toLowerCase(),
      });
    }

    const toolLink = event.target.closest?.('.eih-tool-links a[href], .eih-guidance-final__card[href]');
    if (toolLink) {
      publish('tool_opened', {
        tool_path: pathFrom(toolLink.href),
        label: toolLink.textContent.trim().slice(0, 80),
      });
    }

    const guidedResult = event.target.closest?.('[data-eih-result-link][href]');
    if (guidedResult) {
      publish('finder_result_clicked', {
        result_path: pathFrom(guidedResult.href),
      });
    }

    const contentProduct = event.target.closest?.('.evc__commerce a[href*="/products/"]');
    if (contentProduct) {
      publish('content_product_clicked', {
        product_path: pathFrom(contentProduct.href),
        surface: 'editorial_commerce',
      });
    }

    const miniProduct = event.target.closest?.('.eih-mini-product a[href*="/products/"]');
    if (miniProduct) {
      publish('guidance_product_clicked', {
        product_path: pathFrom(miniProduct.href),
        surface: 'homepage_guidance',
      });
    }

    const homeCard = event.target.closest?.('.eih-product-card');
    if (homeCard && !event.target.closest('[data-eih-wish]')) {
      const productLink = event.target.closest('a[href*="/products/"]') || homeCard.querySelector('h3 a[href*="/products/"]');
      if (productLink) {
        publish('homepage_product_clicked', {
          product_path: pathFrom(productLink.href),
          filter: String(homeCard.dataset.eihProductCategory || 'all'),
          surface: 'homepage_curated',
        });
      }
    }

    const recommendation = event.target.closest?.(
      'product-recommendations a[href*="/products/"], related-products a[href*="/products/"], complementary-products a[href*="/products/"]'
    );
    if (recommendation) {
      publish('product_recommendation_clicked', {
        product_path: pathFrom(recommendation.href),
        surface: 'product_recommendation',
      });
    }
  }, true);
})();
